// extracted by mini-css-extract-plugin
module.exports = {"frame":"FramerWebsite_frame__3YTbK"};